// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3S4an","colCheckbox":"styles_colCheckbox__25CZl"};